import { createItem, readItem, readItems } from "@directus/sdk";
import { getDirectusClient } from "../lib/directus";

const directus = getDirectusClient();

export const CreateHistorial = async (data) => {
  try {
    const response = await directus.request(
      createItem("historial_seriales", {
        ...data,
      })
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const CreateHistorialDetalle = async (data) => {
  try {
    const response = await directus.request(
      createItem("detalle_historial_ns", {
        ...data,
      })
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const getHistorialDetalle = async () => {
  try {
    const response = await directus.request(
      readItems("detalle_historial_ns", { fields: ["*.*"] })
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const getHistorialDetalleById = async (id) => {
  try {
    const response = await directus.request(
      readItem("detalle_historial_ns", { fields: ["*.*"], filter: { id: id } })
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const getHistorialDetalleByIdProducto = async (
  id,
  limit = 5,
  offset = 0
) => {
  try {
    const response = await directus.request(
      readItems("detalle_historial_ns", {
        fields: [
          "cantidad",
          "id",
          "user_created.id",
          "user_created.first_name",
          "prestamo_ns_p.estado",
          "prestamo_ns_p.cantidad",
          "prestamo_ns_p.date_created",
          "prestamo_ns_p.id",
          "prestamo_ns_p.inventario_ns.cantidad",
          "prestamo_ns_p.inventario_ns.nombre",
          "prestamo_ns_p.inventario_ns.id",
          "prestamo_ns_p.inventario_ns.producto",
          "historial_seriales.historial_seriales_id",
        ],
        filter: { prestamo_ns_p: { _eq: id } },
        limit,
        offset,
        sort: ["-prestamo_ns_p.date_created"],
      })
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const getHistorialDetalleByIdProductoCount = async (id) => {
  try {
    const response = await directus.request(
      readItems("detalle_historial_ns", {
        fields: ["*"],
        aggregate: {
          countDistinct: ["id"],
        },
        filter: { prestamo_ns_p: { _eq: id } },
      })
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const getHistorialSeriales = async () => {
  try {
    const response = await directus.request(
      readItems("historial_seriales", { fields: ["*.*"] })
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const getHistorialSerialesById = async (id) => {
  try {
    const response = await directus.request(
      readItems("historial_seriales", {
        fields: [
          "inventario_ns_pd.*",
          "prestamo.id",
          "prestamo.tipo",
          "prestamo.estado",
          "prestamo.vendedor.first_name",
          "user_created.first_name",
          "user_created.id",
          "factura_n.consecutivo",
          "factura_n,cliente",
          "factura_n.caja",
          "factura_n.bodega",
          "factura_n.productos.cantidad",
          "factura_n.productos.producto.nombre",
          "factura_n.productos.producto.id",
          "factura_n.productos.producto.precio_unitario",
          "factura_n.productos.producto.preciosinimp",
          "factura_n.productos.producto.grupo.impuesto",
          "factura_n.productos.producto.date_created"
        ],
        filter: { id: id },
      })
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const getHistorialSerialesByInventario = async (id) => {
  try {
    const response = await directus.request(
      readItem("historial_seriales", {
        fields: ["*.*"],
        filter: { inventario_ns_pd: { id: { _eq: id } } },
      })
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const getHistorialDetalleByIdProductoBatch = async (
  ids,
  limit = 100,
  offset = 0
) => {
  try {
    const response = await directus.request(
      readItems("detalle_historial_ns", {
        fields: [
          "cantidad",
          "id",
          "user_created.id",
          "user_created.first_name",
          "prestamo_ns_p.estado",
          "prestamo_ns_p.cantidad",
          "prestamo_ns_p.date_created",
          "prestamo_ns_p.producto.*",
          "prestamo_ns_p.id",
          "prestamo_ns_p.inventario_ns.cantidad",
          "prestamo_ns_p.inventario_ns.nombre",
          "prestamo_ns_p.inventario_ns.id",
          "prestamo_ns_p.inventario_ns.producto",
          "historial_seriales.historial_seriales_id",
        ],
        filter: { prestamo_ns_p: { _in: ids } },
        limit,
        offset,
        sort: ["-prestamo_ns_p.date_created"],
      })
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const getHistorialSerialesByIdBatch = async (ids) => {
  try {
    const response = await directus.request(
      readItems("historial_seriales", {
        fields: [
          "id",
          "inventario_ns_pd.*",
          "inventario_ns_pd.producto.*",
          "prestamo.*",
          "prestamo.id",
          
          "prestamo.vendedor.id",
          "prestamo.vendedor.first_name",
          "user_created.first_name",
          "user_created.id",
          "factura_n.id",
          "factura_n.consecutivo",
          "factura_n,cliente",
          "factura_n.caja",
          "factura_n.bodega",
          "factura_n.productos.cantidad",
          "factura_n.productos.producto.nombre",
          "factura_n.productos.producto.id",
          "factura_n.productos.producto.precio_unitario",
          "factura_n.productos.producto.preciosinimp",
          "factura_n.productos.producto.grupo.impuesto",
          "factura_n.productos.producto.date_created"
        ],
        filter: { id: { _in: ids } },
      })
    );
    return response;
  } catch (error) {
    throw error;
  }
};
